module.exports = __webpack_public_path__ + "615067234e4bcd0b2443d0a1b702942e.png";